import * as React from 'react'

import {
  AttendanceCustomPeriodEmployeeItemFragment,
  AttendanceSidepanelCompensationBlockFragment,
} from 'generated/resources/graphql'

import CompensationOverview from 'modules/attendance/components/ClockIn/TabsBreakdown/CompensationPannel/Overview'
import { useAttendanceFeatures } from 'modules/attendance/lib/attendanceFeaturesContext'
import type { BOHAllocationState } from 'modules/attendance/lib/types'
import EmployeesSettingsUtils from 'modules/attendance/lib/utils/EmployeesSettingsUtils'

interface CompensationTabProps {
  employee: AttendanceCustomPeriodEmployeeItemFragment
  setSelectedCompensationBlocks: React.Dispatch<
    React.SetStateAction<AttendanceSidepanelCompensationBlockFragment[]>
  >
  onHasErrorsChange?: (hasErrors: boolean) => void
  bohAllocation?: BOHAllocationState | null
  onBOHAllocationChange?: (allocation: BOHAllocationState) => void
}

export const CompensationTab = ({
  employee,
  setSelectedCompensationBlocks,
  onHasErrorsChange,
  bohAllocation,
  onBOHAllocationChange,
}: CompensationTabProps) => {
  const isPartTime = !!employee.referenceContract?.partTime
  const policySettings =
    employee.attendanceEmployeesPolicy?.attendanceEmployeesSettingsConnection?.edges?.[0]?.node
  const { featureAvailability: hasComplementaryHoursFeature } = useAttendanceFeatures(
    'dev_time_tracking_complementary_hours'
  )
  const useComplementaryHoursLabels =
    hasComplementaryHoursFeature && isPartTime && !!policySettings?.enableComplementaryHours

  const employeesSettings = policySettings ? [policySettings] : []
  const payrollCompensationEnabled =
    EmployeesSettingsUtils.hasPayrollCompensationEnabled(employeesSettings)
  const timeoffCompensationEnabled =
    EmployeesSettingsUtils.hasTimeoffCompensationEnabled(employeesSettings)
  const allowManualAllocationEnabled =
    EmployeesSettingsUtils.hasAllowManualAllocationEnabled(employeesSettings)

  if (!employee.id) {
    return null
  }

  return (
    <CompensationOverview
      setSelectedCompensationBlocks={setSelectedCompensationBlocks}
      employeeId={employee.id}
      useComplementaryHoursLabels={useComplementaryHoursLabels}
      onHasErrorsChange={onHasErrorsChange}
      payrollCompensationEnabled={payrollCompensationEnabled}
      timeoffCompensationEnabled={timeoffCompensationEnabled}
      allowManualAllocationEnabled={allowManualAllocationEnabled}
      bohAllocation={bohAllocation}
      onBOHAllocationChange={onBOHAllocationChange}
    />
  )
}
